<template>
    <form id="mainFrom" action="#" method="post">
        <card>
            <template #title>
                <Toolbar>
                    <template #left>
                       <div class="p-card-title">
                            [{{ mode }}] Version Log
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />
                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>
                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Version" class="col-4">{{ $t('version') }}<span style="color: red;">*</span></label>
                                <div class="col-8 md-8">
                                    <InputText name="Version" v-model="header.Version" type="text" :placeholder="$t('version')"
                                        v-if="header" :class="{ 'p-invalid': submitted && !header.Version }"
                                        :disabled="mode == this.$FORM_MODE_DELETE || mode == this.$FORM_MODE_VIEW"
                                        />
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.Version && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('version')) }}
                                    </small>
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Version_Date" class="col-4">{{ $t('version_date') }}<span style="color: red;">*</span></label>
                                <div class="col-8 md-8">
                                    <DatePicker
                                        name="Version_Date"
                                        v-model="header.Version_Date"
                                        :placeholder="$t('version_date')"
                                        v-if="header"
                                        :class="{ 'p-invalid': submitted && !header.Version_Date }"
                                        :disabled="mode == this.$FORM_MODE_DELETE || mode == this.$FORM_MODE_VIEW"
                                        dateFormat="dd/mm/yyyy"
                                        inputMask="99/99/9999"
                                        momentFormat="DD/MM/YYYY"
                                    />
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.Version_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('version_date')) }}
                                    </small>
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Remark" class="col-4">{{ $t('remark') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Remark" v-model="header.Remark" type="text" :placeholder="$t('remark')"
                                        v-if="header"
                                        :disabled="mode == this.$FORM_MODE_DELETE || mode == this.$FORM_MODE_VIEW"
                                        />
                                    <Skeleton v-else-if="!header" />
                                </div>
                            </div>
                            <div class="field grid">
                                <div class="col-8 md-8">
                                    <FormField :labelName="$t('active')" fieldName="Active" v-model="header" labelClass="col-6" v-if="header">
                                        <Checkbox 
                                            v-model="header.Active" 
                                            v-if="header" 
                                            :binary="true"
                                            :disabled="mode == this.$FORM_MODE_DELETE || mode == this.$FORM_MODE_VIEW"
                                        />
                                    </FormField> 
                                </div>
                            </div>
                        </div>
                        <div class="col-6" v-if="mode == this.$FORM_MODE_EDIT">
                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-8 md-8" v-if="header">
                                <InputText name="Reason" v-model="header.Reason" type="text" :placeholder="$t('reason')" 
                                v-if="header" :disabled="mode != this.$FORM_MODE_EDIT"/>
                                <small v-if="header && !header.Reason && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                </small>
                            </FormField>
                        </div>
                        <div class="col-12">                    
                                <DataTable v-if="header" :loading="!header" :value="header.Details ? header.Details : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetail()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetail(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
                                <Column field="Description" :header="$t('description')" Key="Area">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('description')" @change="onCellEditComplete(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
              <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                         <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                 <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
              </div>
            </template>

        </card>
    </form>
</template>
<script>
export default {
    name: "Editor",
    data() {
        return {
            indexName: "VersionLogIndex",
            url: this.$API_URL + "VersionLog/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataChangesLog:this.$dataChangesLogMasterData,
            detailLog : null,
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            detailname : null,
        }
    },
    methods: {
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.detail = response.data.data.detail;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.detailLog = self.header.DetailLog;
                })
                .catch(function (error) {
                    alert(error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if(self.header.mode == self.$FORM_MODE_CREATE)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Version " + self.header.Version + " has been Create successfully", life: 3000 } });
                        else if(self.header.mode == self.$FORM_MODE_EDIT || self.header.mode == self.$FORM_MODE_DRAFT_EDIT)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Version " + self.header.Version + " has been Edit successfully", life: 3000 } });
                        else if(self.header.mode == self.$FORM_MODE_DELETE)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Version " + self.header.Version + " has been Delete successfully", life: 3000 } });
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            this.$router.push({ path: "/VersionLog/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            var self = this;
            if (!this.header.Version || !this.header.Version_Date || (this.header.mode == self.$FORM_MODE_EDIT && !this.header.Reason)) {
                return;
            }
            
            if(this.header.Details.length == 0){
                self.showError("Error", "Must have one description");
                return;
            }   

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Details.push(det);
        },
        deleteDetail(event) {
            if (event) {
              
                var detail = this.header.Details[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Details.splice(this.header.Details.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;

        this.getData();
    }
};
</script>